import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'layout/Root';

ReactDOM.render(<Root />, document.getElementById('root'));
